import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";

import Loader from "components/Custom/Loader";
import AutoComplete from "components/Custom/AutoComplete";
import TxtBox from "components/Custom/TxtBox";
import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";

import {
  LABELS,
  ERRORS,
  WARNINGS,
  SUCCESS,
  CONFIRMS,
  TITLES,
  SUB_TITLES,
} from "common/labels";
import { DateFunctions } from "common//datefunctions";
import { COMMON_JS } from "common/scripts";
import { NOTIFY } from "common/config";
import { ApiReports } from "apihandlers//reports";
const ApiReportsHandler = new ApiReports();

const DriversList = (props: any) => {
  const { setDashMenu } = props;
  const [loading, setLoading] = useState(false);
  const [chartData, setChartData] = useState<any>({});
  const [rows, setRows] = useState<any>(null);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [exportName, setExportName] = useState("");
  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "dlNumber",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DL_NUMBER,
      width: "10%",
    },
    {
      key: "issuingAuthority",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DL_ISSUING_AUTHORITY,
      width: "10%",
    },
    {
      key: "dateOfIssue",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DL_ISSUED_ON,
      width: "10%",
    },
    {
      key: "expiryDate",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DL_VALID_UPTO,
      width: "10%",
    },
    {
      key: "swdOf",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.SWD_OF,
      width: "10%",
    },
    {
      key: "vehicleType",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.VEHICLE_TYPE,
      width: "10%",
    },
    {
      key: "userName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.USER_NAME,
      width: "10%",
    },
    {
      key: "mobileNumber",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.MOBILE_NO,
      width: "10%",
    },
    {
      key: "mobileNumber2",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.MOBILE_ALTERNATIVE,
      width: "10%",
    },
    {
      key: "employeeCode",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.EMPLOYEE_CODE,
      width: "10%",
    },
    {
      key: "accountNumber",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ACCOUNT_NUMBER,
      width: "10%",
    },
    {
      key: "bankName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.BANK_NAME,
      width: "10%",
    },
    {
      key: "ifscCode",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.IFSC_CODE,
      width: "10%",
    },
    {
      key: "mobileCug",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.MOBILE_CUG,
      width: "10%",
    },
    {
      key: "dateOfBirth",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DATE_OF_BIRTH,
      width: "10%",
    },
    {
      key: "aadharNumber",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.AADHAR_NUMBER,
      width: "10%",
    },
    {
      key: "panNumber",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.PAN_NUMBER,
      width: "10%",
    },
    {
      key: "uanNumber",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.UAN_NUMBER,
      width: "10%",
    },
    {
      key: "joiningDate",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.JOINING_DATE,
      width: "10%",
    },
    {
      key: "trDueDate",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.TR_DUE_DATE,
      width: "10%",
    },
    {
      key: "ntDueDate",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.NT_DUE_DATE,
      width: "10%",
    },
    {
      key: "activeStatus",
      name: LABELS.ACTIVE,
      width: "6%",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
    },
  ];

  const loadChart = () => {
    const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
      .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
    setExportName(
      LABELS.FROM_DATE + ":" + fromDt + "\n" + LABELS.TO_DATE + ":" + toDt
    );
    const args = {
      fromDt,
      toDt,
      reportType: "excel",
    };
    let errors = [];
    if (fromDt == "") {
      errors.push({
        id: "fromDt",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDt == "") {
      errors.push({
        id: "toDt",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }
    setChartData(null);
    ApiReportsHandler.getDriverReport(args).then((res) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        const list = response.rows;
        for (let i = 0; i < response.rows.length; i++) {
          response.rows[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatus"] = "Yes";
          } else {
            list[i]["activeStatus"] = "No";
          }
        }
        setChartData(response);
        setRows(response.rows);
      }
    });
  };

  const projectRef: any = useRef();

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>

          <li className="dim">{" / "}</li>
          <li onClick={() => props.setDashMenu(LABELS.HOME)}>
            {LABELS.REPORTS}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.DRIVERS_LIST_REPORT}</li>
        </ul>
        <h4>{TITLES.DRIVERS_LIST_REPORT}</h4>
        <p className="SubTitles">{SUB_TITLES.DRIVERS_LIST_REPORT}</p>
      </div>
      {loading ? (
        <div className="flexCenter" style={{ minHeight: 450 }}>
          <Loader />
        </div>
      ) : (
        <div className="hChart">
          <div id="chartForm">
            <div
              className="formGroup"
              style={{
                display: "flex",
                marginTop: 5,
                marginBottom: 20,
              }}
            >
              <div
                style={{
                  display: "flex",
                  marginRight: 15,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label
                  style={{
                    fontWeight: "500",
                    fontSize: 14,
                    marginTop: 6,
                    marginRight: 8,
                  }}
                >
                  {LABELS.FROM_DATE}
                </label>
                <TxtBox
                  type={"date"}
                  id="fromDt"
                  defaultValue={DateFunctions.getDate(
                    "today",
                    "from",
                    "YYYY-MM-DD"
                  )}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  marginRight: 15,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label
                  style={{
                    fontWeight: "500",
                    fontSize: 14,
                    marginTop: 6,
                    marginRight: 8,
                  }}
                >
                  {LABELS.TO_DATE}
                </label>
                <TxtBox
                  type={"date"}
                  id="toDt"
                  defaultValue={DateFunctions.getDate(
                    "thismonth",
                    "to",
                    "YYYY-MM-DD"
                  )}
                />
              </div>

              <div
                style={{
                  display: "flex",
                }}
              >
                <Btn
                  text={LABELS.LOAD}
                  onClick={loadChart}
                  // loading={!chartData}
                />
              </div>
            </div>
          </div>
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          {rows && (
            <ExcelGrid
              id={"driverListReport"}
              title={LABELS.DRIVERS_LIST_REPORT}
              height={window.innerHeight * 0.8}
              cols={columns}
              rows={rows}
              exportOption={true}
              newRowOption={false}
              exportName={exportName}
            />
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(DriversList);
